import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, Output, EventEmitter, HostListener } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CaseTask } from '../outbox.component';
import { Responsible, CompanyInformation, Fitter } from '../../shared-html-components/details/models';
import { Department, SharedDataService } from '../../shared/services/shared-data.service';
import { PartnerCompany } from 'app/shared/api/partner.api';
import { Router } from '@angular/router';
import { CompanyUsers } from '../../settings/users/users.component';
import { CaseDetails } from '../../shared-html-components/details/details.component';
import { createPopper } from '@popperjs/core';
import * as api from '../../shared/api/apihandler';
import { SubscriptionObject } from 'app/shared/models/standard.models';
import { DateUtilities } from 'app/shared/utilities/dateUtilities';

@Component({
  selector: 'app-transfer-case',
  templateUrl: './transfer-case.component.html',
  styleUrls: ['./transfer-case.component.css']
})

export class TransferCaseComponent implements OnInit, OnDestroy {
  @Input() case: CaseDetails;
  @Input() openModal = false;
  @Input() type: string;
  @Output() update = new EventEmitter();
  @Output() reload = new EventEmitter();
  subscriptions: SubscriptionObject = {};
  data = new CaseTransferDataHolder();
  input = new CaseTransferChanges();
  time = new TimePickerRanges();
  bsConfig = DateUtilities.bsConfig;
  isOffer = false;
  newCaseCustomer = null;
  newCaseCustomerChanged;
  newCaseDelivery = false;
  newCaseContact = false;
  transferCase = false;
  customerData;
  light = false;
  dblClick = null;
  foreman;
  eorderGroupList;
  currentEOrderGroup = null;
  osStatus = 99991;
  edepartmentList;
  currentEDepartment = null;
  edimensionCarrierList;
  currentEDimensionCarrier = null;
  epriceGroupList;
  currentEPriceGroup = null;
  eDimensionPuposeList;
  currentEDimensionPurpose = null;
  loading = false;
  eProfitGroupList;
  currentEProfitGroup = null;
  customerChange = false;
  createdCaseId: string = null;
  transferMessage = false;
  receiverCaseId = null;
  customerList;
  currentCaseType = null;

  constructor(private httpClient: HttpClient, private sharedData: SharedDataService, private router: Router) { }

  ngOnInit() {
    this.data.integrationId = localStorage.getItem('integration') as string;
    this.data.lightCustomer = JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'Udbakke Light') != null ? true : false;
    this.data.lightCustomer = JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'Udbakke') != null ? false : this.data.lightCustomer;
    this.subscriptions['companyInfo'] = this.sharedData.companyInformation().subscribe((data) => { this.data.companyInfo = data });
    this.subscriptions['responsibles'] = this.sharedData.responsibles().subscribe((data) => { this.data.responsibles = data; this.foreman = data });
    this.subscriptions['companyUsers'] = this.sharedData.companyUsers().subscribe((data) => {
      if (!!data) {
        this.data.companyUsers = data.filter(x => !!x.externalId);
        //console.log(this.data.companyUsers)
      }
    });
    this.subscriptions['fitters'] = this.sharedData.fitter().subscribe((data: any) => { this.data.fitters = data; /*console.log(data)*/ });
    this.getIntegration();
    this.getTypesByIntegration();
  }

  ngOnChanges(change: SimpleChanges) {
    this.isOffer = false;
    if (!!change.case && change.case.currentValue != change.case.previousValue) {
      // console.log(this.case)
      this.foreman.key = this.case.responsible.responsibleId;
      this.foreman.value = this.case.responsible.name
    }
    if (this.openModal || change.case != null && change.case.currentValue != null) {
      this.transferCase = change.case.currentValue.transferId != null ? false : true;
      this.createdCaseId = null;
      this.newCaseCustomer = null;
      if (change.case.currentValue.transferId != null) {
        this.getPartnerCase(change.case.currentValue);
      }
      if (this.type == 'partner') {
        let ex = this.case.externalId;
        this.case.requisitionNumber = !!this.case.caseNumber ? this.case.caseNumber : (!!ex && ex.length < 15 ? ex : '');
        this.case.vorRef = this.case.responsible.name;
      }
      this.input = new CaseTransferChanges();
      this.input.caseTypeId = this.data.caseTypes != null && this.data.caseTypes.length > 0 ? this.data.caseTypes.sort((a, b) => a.id > b.id ? 1 : -1)[0].id : null;
      this.input.debitorTypeId = this.data.debitorTypes != null && this.data.debitorTypes.length > 0 ? this.data.debitorTypes.sort((a, b) => a.id > b.id ? 1 : -1)[0].number : null;
      this.input.customerTypeId = this.data.customerTypes != null && this.data.customerTypes.length > 0 ? this.input.customerTypeId = this.data.customerTypes.sort((a, b) => a.id > b.id ? 1 : -1)[0].id : null;
      this.getTask();
      document.getElementById('transferCaseModalOpener').click();
    }

  }

  ngOnDestroy() {
    this.isOffer = false;
    for (let x of Object.keys(this.subscriptions)) { this.subscriptions[x].unsubscribe() }
  }

  AddMessageToCase() {
    //console.log(this.case)
    this.transferMessage = true;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.post(api.jubloApi + 'api/Website/Case/MessageFromTransfer', {
      "CaseId": this.receiverCaseId,
      "Description": this.case.description,
      "Title": this.case.title
    }, { headers }).subscribe(
      val => { /*console.log('val', val);*/ },
      response => { console.log('Error!', response) },
      () => {
        this.httpClient.put(api.jubloApi + 'api/Website/CaseTransfer/CaseTransferStatus/' + this.newCaseCustomer.transferId + '/789e1326-6655-4e98-bcd1-41c527e32d93',
          {}, { headers }).subscribe(
            () => {
              document.getElementById('transferCaseCloseModalBtn').click();
              this.update.emit('mailRemoved');
            }
          )
        this.transferMessage = false;
        this.receiverCaseId = null;
      }
    );
  }

  getPartnerCase(input) {
    this.isOffer = false;
    //console.log(input)
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/CaseTransfer/CaseTransfer/' + input.transferId, { headers }).subscribe(
      (data: any) => {
        //console.log(data)
        this.newCaseCustomer = {
          customer: data.customer,
          invoice: data.invoice,
          delivery: data.delivery,
          contact: data.contact,
          transferId: input.transferId,
          transferTypeId: input.transferTypeId,
          origin: input.origin,
          title: input.title,
          files: data.files,
          description: input.description,
          responsibleId: input.responsible.responsibleId,
          requisitionNumber: input.requisitionNumber,
          disableNotifications: true,
          reference: input.vorRef,
          caseTypeId: null,
          caseChannel: null,
          isOfferRequest: !!data.isOfferRequest ? data.isOfferRequest : false
        }
        //console.log(this.newCaseCustomer)
        if (data.isOfferRequest) { this.isOffer = true; }
        this.createdCaseId = null;
      },
      () => { },
      () => {
      }
    );
  }

  getIntegration() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get<any>(api.jubloApi + 'api/Minuba/GetIntegration', { headers }).subscribe(
      (data) => {
        this.data.activeIntegration = data;
      },
      err => console.error(err),
      () => { }
    );
  }

  getTypesByIntegration() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    switch (this.data.integrationId) {
      // Orderstyrning
      case ('58ecfda6-79a6-4507-80ac-29b6d025360b'): {
        this.httpClient.get(api.jubloApi + 'api/Minuba/GetOSTypes', { headers }).subscribe(
          (data: Array<any>) => {
            this.data.caseTypes = data.map(x => { return { id: x.id, name: x.text, sort: x.sortOrder } }).sort((a,b)=> a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
          },
          err => console.error(err),
          () => { }
        );
        this.httpClient.get(api.jubloApi + 'api/Minuba/GetOSCustomerGroups', { headers }).subscribe(
          (data: any) => { this.data.customerTypes = data; },
          (response) => { },
          () => { }
        );
        this.httpClient.get(api.jubloApi + 'api/Minuba/GetOSeconomySystemGroups', { headers }).subscribe(
          (data: any) => { this.data.debitorTypes = data; },
          response => { },
          () => { }
        );
        this.httpClient.get(api.jubloApi + 'api/Minuba/GetOSDepartments', { headers }).subscribe(
          (data: any) => { this.data.departments = data; }
        );
        this.httpClient.get(api.jubloApi + 'api/Minuba/GetOSStatus', { headers }).subscribe(
          (data: any) => { this.data.osStatuses = data; }
        );
        break;
      }
      // Minuba
      case ('2fdf7795-d8dc-4dcc-863b-9654ef98b1a0'): {
        this.httpClient.get(api.jubloApi + 'api/Minuba/OrderTypes', { headers }).subscribe((data: any) => {
          this.data.caseTypes = data.ordertypes;
        })
        break;
      }
      case ('7e82cc3e-163e-4cb2-ba25-939fc339f021' || 'b81c660a-bc82-4c6b-a820-4f8804bdf68e'): {
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        this.httpClient.get(api.jubloApi + 'api/Outbox/Ekomplet/OrderGroup', { headers }).subscribe(
          (data) => {
            //console.log(data)
            this.eorderGroupList = data;
          },
          (response) => { console.log('Error!', response); }
        )
      }
        this.httpClient.get(api.jubloApi + 'api/Outbox/Ekomplet/Department', { headers }).subscribe(
          (data) => {
            //console.log(data)
            this.edepartmentList = data;
          },
          (response) => { console.log('Error!', response); }
        )
        this.httpClient.get(api.jubloApi + 'api/Outbox/Ekomplet/DimensionCarrier', { headers }).subscribe(
          (data) => {
            //console.log(data)
            this.edimensionCarrierList = data;
          },
          (response) => { console.log('Error!', response); }
        )
        this.httpClient.get(api.jubloApi + 'api/Outbox/Ekomplet/PriceGroup', { headers }).subscribe(
          (data) => {
            //console.log(data)
            this.epriceGroupList = data;
          },
          (response) => { console.log('Error!', response); }
        )
        this.httpClient.get(api.jubloApi + 'api/Outbox/Ekomplet/ProfitGroup', { headers }).subscribe(
          (data) => {
            //console.log(data)
            this.eProfitGroupList = data;
          },
          (response) => { console.log('Error!', response); }
        )
        this.httpClient.get(api.jubloApi + 'api/Outbox/Ekomplet/DimensionPurpose', { headers }).subscribe(
          (data) => {
            //console.log(data)
            this.eDimensionPuposeList = data;
          },
          (response) => { console.log('Error!', response); }
        )
        break;
    }
  }

  getTask() {
    if (this.case.caseId != null) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.get(api.jubloApi + 'api/Website/Case/GetCaseTasks/' + this.case.caseId, { headers }).subscribe(
        (data: Array<CaseTask>) => { this.input.caseTask = data[0]; },
        () => { },
        () => { }
      );
    }
  }

  originName(id) {
    //console.log(id);
    switch (id) {
      case ('58ecfda6-79a6-4507-80ac-29b6d025360b'): { return 'Ordrestyring'; }
      case ('9f9776f1-7be5-40d6-813e-ef795aba3e73'): { return 'Jublo'; }
      case ('f84e1968-4cc4-4824-936e-441d4984284f'): { return 'Jublo'; }
      case ('4669a7be-4bfe-4046-aee1-3675f545dc9b'): { return 'Rekvisitioner'; }
      case ('2fdf7795-d8dc-4dcc-863b-9654ef98b1a0'): { return 'Minuba'; }
      case ('61ae61e5-8e71-44da-9c0c-72b6a752a697'): { return 'AO'; }
      case ('5a735683-e237-4084-885e-32f8cec5f9cf'): { return 'KlarPris'; }
      case ('cd80e0f1-f6c9-42a1-b2e8-3df714620304'): { return 'EGOne'; }
      case ('b81c660a-bc82-4c6b-a820-4f8804bdf68e'): { return 'EKomplet'; }
      case ('7e82cc3e-163e-4cb2-ba25-939fc339f021'): { return 'EKomplet'; }
      case ('5B3942BA-7118-4B25-80AF-53F5D13EF779'): { return 'Navision'; }
      case ('DD26BA61-4B4B-4827-AE16-D14C46EE5338'): { return 'BilligVVS.dk'; }
      default: { return 'Jublo'; }
    }
  }

  // Case Changes
  updateCaseInfo() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.put(api.jubloApi + 'api/Website/Case/EditCase/' + this.case.caseId, {
      title: this.case.title,
      description: this.case.description,
      requisitionNumber: this.case.requisitionNumber,
      vorRef: this.case.vorRef,
      internalNote: this.case.internalNote
    }, { headers }).subscribe(
      val => { /*console.log('val', val);*/ },
      response => { console.log('Error!', response) },
      () => {
        this.sendCase();
        this.dblClick = null;
      }
    );
  }

  changeResponsible() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.patch(api.jubloApi + 'api/Website/Case/ChangeResponsible/' + this.case.caseId + '/' + this.case.responsible.responsibleId, {}, { headers }).subscribe(
      val => { /*console.log('val', val);*/ },
      response => { /*console.log('response', response);*/ },
      () => {
      }
    );
  }

  createTask() {
    if (this.input.planDate == null) {
      return console.log('no date chosen');
    }
    let duration = (+this.input.planHours * 60) + +this.input.planMinutes;
    let startTime = DateUtilities.mergeDateAndTime(new Date(this.input.planDate), this.input.planTime).toISOString();
    // let startTime = new Date(this.input.planDate + 'T' + this.input.planTime + ':00.000').toISOString();
    let end = new Date(startTime).setMinutes(new Date(startTime).getMinutes() + duration);
    let endTime = new Date(end).toISOString();

    if (this.input.caseTask == null) {
      //console.log('create task on case: ' + this.selectedCase[0].caseId, this.planFitter, startTime, endTime);
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.post(api.jubloApi + 'api/Website/Case/CreateCaseTask/' + this.case.caseId, {
        "customerId": this.case.customer.customerId,
        "fitterId": this.input.planFitter,
        "startTime": startTime,
        "endTime": endTime
      }, { headers }).subscribe(
        val => { /*console.log('val', val);*/ },
        response => { /*console.log('response', response);*/ },
        () => {
          const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
          this.httpClient.get(api.jubloApi + 'api/Website/Case/GetCaseTasks/' + this.case.caseId, { headers }).subscribe(
            (data: Array<CaseTask>) => {
              this.input.caseTask = data[0];
            },
            () => { },
            () => { }
          );
        }
      );
    } else {
      //console.log('edit taskid: ' + this.selectedCaseTask.taskId, this.planFitter, startTime, endTime);
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.put(api.jubloApi + 'api/Website/Case/EditTask/' + this.input.caseTask.taskId, {
        "fitterId": this.input.planFitter,
        "startTime": startTime,
        "endTime": endTime
      }, { headers }).subscribe(
        val => { /*console.log('val', val);*/ },
        response => { /*console.log('response', response);*/ },
        () => {
          const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
          this.httpClient.get(api.jubloApi + 'api/Website/Case/GetCaseTasks/' + this.case.caseId, { headers }).subscribe(
            (data: Array<CaseTask>) => {
              this.input.caseTask = data[0];
            },
            () => { },
            () => { }
          );
        }
      );
    }
  }

  deleteTask() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.delete(api.jubloApi + 'api/Website/Case/RemoveTask/' + this.input.caseTask.taskId, { headers }).subscribe(
      (data: Array<CaseTask>) => {
        this.input.caseTask = undefined;
      },
      (err) => { console.log(err) },
      () => {
        this.getTask();
      }
    );
  }

  acceptOffer() {
    //console.log('acceptiong offer ' + this.case.caseId);
    this.loading = true;
    if (this.dblClick == null) {
      this.dblClick = new Date().getTime();
    }
    let n = this.newCaseCustomer;
    let c = this.newCaseCustomerChanged;
    let contactSkip = false;
    let deliverySkip = false;
    //console.log(c, n);
    if (!!c) {
      contactSkip = !!c.contact.name || !!c.contact.address || !!c.contact.zipCode || !!c.contact.city || !!c.contact.phone || !!c.contact.mobile || !!c.contact.email ? false : true;
      deliverySkip = !!c.delivery.customerName || !!c.delivery.customerAddress || !!c.delivery.customerZipCode || !!c.delivery.customerCity || !!c.delivery.customerPhone || !!c.delivery.customerMobile || !!c.delivery.customerMail ? false : true;
    } else {
      contactSkip = !!n.contact.name || !!n.contact.address || !!n.contact.zipCode || !!n.contact.city || !!n.contact.phone || !!n.contact.mobile || !!n.contact.email ? false : true;
      deliverySkip = !!n.delivery.name || !!n.delivery.address || !!n.delivery.zipCode || !!n.delivery.city || !!n.delivery.phone || !!n.delivery.mobile || !!n.delivery.email ? false : true;
    }
    let d = {
      "title": n.title,
      "description": n.description,
      "customer": {
        "customerName": !!c ? c.customer.customerName : n.customer.name,
        "customerAddress": !!c ? c.customer.customerAddress : n.customer.address,
        "customerZipCode": !!c ? c.customer.customerZipCode : n.customer.zipCode,
        "customerCity": !!c ? c.customer.customerCity : n.customer.city,
        "customerTelephone": !!c ? (!!c.customer.customerPhone && c.customer.customerPhone != null ? c.customer.customerPhone.replace(/\s/g, '') : '') : (!!n.customer.phone && n.customer.phone != null ? n.customer.phone.replace(/\s/g, '') : ''),
        "customerFax": null,
        "customerEmail": !!c ? c.customer.customerMail : n.customer.email,
        "customerMobile": !!c ? (!!c.customer.customerMobile && c.customer.customerMobile != null ? c.customer.customerMobile.replace(/\s/g, '') : '') : (!!n.customer.mobile && n.customer.mobile != null ? n.customer.mobile.replace(/\s/g, '') : ''),
        "invoiceName": !!c ? c.customer.invoiceName : n.invoice.name,
        "invoiceAddress": !!c ? c.customer.invoiceAddress : n.invoice.address,
        "invoiceZipCode": !!c ? c.customer.invoiceZipCode : n.invoice.zipCode,
        "invoiceCity": !!c ? c.customer.invoiceCity : n.invoice.city,
        "invoiceTelephone": !!c ? (!!c.customer.invoicePhone && c.customer.invoicePhone != null ? c.customer.invoicePhone.replace(/\s/g, '') : '') : (!!n.invoice.phone && n.invoice.phone != null ? n.invoice.phone.replace(/\s/g, '') : ''),
        "invoiceFax": null,
        "invoiceEmail": !!c ? c.customer.invoiceEmail : n.invoice.email,
        "invoiceMobile": !!c ? (!!c.customer.invoiceMobile && c.customer.invoiceMobile != null ? c.customer.invoiceMobile.replace(/\s/g, '') : '') : (!!n.invoice.mobile && n.invoice.mobile != null ? n.invoice.mobile.replace(/\s/g, '') : ''),
        "cvr": null,
        "ean": null,
        "customerRemarks": null,
        "customerAttention": null
      },
      "delivery": {
        "skip": deliverySkip,
        "name": !!c ? c.delivery.customerName : n.delivery.name,
        "address": !!c ? c.delivery.customerAddress : n.delivery.address,
        "zipCode": !!c ? c.delivery.customerZipCode : n.delivery.zipCode,
        "city": !!c ? c.delivery.customerCity : n.delivery.city,
        "telephone": !!c ? (!!c.delivery.customerPhone && c.delivery.customerPhone != null ? c.delivery.customerPhone.replace(/\s/g, '') : '') : (!!n.delivery.phone && n.delivery.phone != null ? n.delivery.phone.replace(/\s/g, '') : ''),
        "mobile": !!c ? (!!c.delivery.customerMobile && c.delivery.customerMobile != null ? c.delivery.customerMobile.replace(/\s/g, '') : '') : (!!n.delivery.mobile && n.delivery.mobile != null ? n.delivery.mobile.replace(/\s/g, '') : ''),
        "email": !!c ? c.delivery.customerMail : n.delivery.email,
        "att": null,
        "ean": null
      },
      "contact": {
        "skip": contactSkip,
        "name": !!c ? c.contact.name : n.contact.name,
        "address": !!c ? c.contact.address : n.contact.address,
        "zipCode": !!c ? c.contact.zipCode : n.contact.zipCode,
        "city": !!c ? c.contact.city : n.contact.city,
        "telephone": !!c ? (!!c.contact.phone && c.contact.phone != null ? c.contact.phone.replace(/\s/g, '') : '') : (!!n.contact.phone && n.contact.phone != null ? n.contact.phone.replace(/\s/g, '') : ''),
        "mobile": !!c ? (!!c.contact.mobile && c.contact.mobile != null ? c.contact.mobile.replace(/\s/g, '') : '') : (!!n.contact.mobile && n.contact.mobile != null ? n.contact.mobile.replace(/\s/g, '') : ''),
        "email": !!c ? c.contact.email : n.contact.email,
        "att": null,
        "ean": null
      },
      "responsibleId": n.responsibleId,
      "requisitionNumber": n.requisitionNumber,
      "disableNotifications": true,
      "caseNumber": null,
      "reference": n.reference,
      "caseTypeId": null,
      "caseChannel": null
    }
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.put(api.jubloApi + 'api/Website/CaseTransfer/CaseTransferStatus/' + this.newCaseCustomer.transferId + '/36249264-3ac4-446b-a85e-81220ebfd518',
      d, { headers }).subscribe(
        (val: string) => {
          //console.log('offer accepted ', val);
          this.createdCaseId = val;
          //console.log(this.createdCaseId + ' accepted');
        }, response => {
          console.log('Create case-offer failed ', response);
          this.dblClick = null;
        }, () => {
          this.dblClick = null;
        }
      );
  }

  goToCase() {
    this.router.navigateByUrl("/Details/" + this.case.caseId);
  }

  updateAndSend(sendToERP) {
    //console.log(sendToERP)
    if (this.dblClick == null) {
      this.dblClick = new Date().getTime();
      if (this.case.caseId != null && !this.data.lightCustomer) {
        this.updateCaseInfo();
      } else {
        let n = this.newCaseCustomer;
        let c = this.newCaseCustomerChanged;
        let contactSkip = false;
        let deliverySkip = false;
        //console.log(c, n);
        if (!!c) {
          contactSkip = !!c.contact.name || !!c.contact.address || !!c.contact.zipCode || !!c.contact.city || !!c.contact.phone || !!c.contact.mobile || !!c.contact.email ? false : true;
          deliverySkip = !!c.delivery.customerName || !!c.delivery.customerAddress || !!c.delivery.customerZipCode || !!c.delivery.customerCity || !!c.delivery.customerPhone || !!c.delivery.customerMobile || !!c.delivery.customerMail ? false : true;
        } else {
          contactSkip = !!n.contact.name || !!n.contact.address || !!n.contact.zipCode || !!n.contact.city || !!n.contact.phone || !!n.contact.mobile || !!n.contact.email ? false : true;
          deliverySkip = !!n.delivery.name || !!n.delivery.address || !!n.delivery.zipCode || !!n.delivery.city || !!n.delivery.phone || !!n.delivery.mobile || !!n.delivery.email ? false : true;
        }
        let d = {
          "title": n.title,
          "description": n.description,
          "customer": {
            "customerId": !!c && !!c.customer.customerId ? c.customer.customerId : null,
            "customerName": !!c ? c.customer.customerName : n.customer.name,
            "customerAddress": !!c ? c.customer.customerAddress : n.customer.address,
            "customerZipCode": !!c ? c.customer.customerZipCode : n.customer.zipCode,
            "customerCity": !!c ? c.customer.customerCity : n.customer.city,
            "customerTelephone": !!c ? (!!c.customer.customerPhone && c.customer.customerPhone != null ? c.customer.customerPhone.replace(/\s/g, '') : '') : (!!n.customer.phone && n.customer.phone != null ? n.customer.phone.replace(/\s/g, '') : ''),
            "customerFax": null,
            "customerEmail": !!c ? c.customer.customerMail : n.customer.email,
            "customerMobile": !!c ? (!!c.customer.customerMobile && c.customer.customerMobile != null ? c.customer.customerMobile.replace(/\s/g, '') : '') : (!!n.customer.mobile && n.customer.mobile != null ? n.customer.mobile.replace(/\s/g, '') : ''),
            "invoiceName": !!c ? c.customer.invoiceName : n.invoice.name,
            "invoiceAddress": !!c ? c.customer.invoiceAddress : n.invoice.address,
            "invoiceZipCode": !!c ? c.customer.invoiceZipCode : n.invoice.zipCode,
            "invoiceCity": !!c ? c.customer.invoiceCity : n.invoice.city,
            "invoiceTelephone": !!c ? (!!c.customer.invoicePhone && c.customer.invoicePhone != null ? c.customer.invoicePhone.replace(/\s/g, '') : '') : (!!n.invoice.phone && n.invoice.phone != null ? n.invoice.phone.replace(/\s/g, '') : ''),
            "invoiceFax": null,
            "invoiceEmail": !!c ? c.customer.invoiceEmail : n.invoice.email,
            "invoiceMobile": !!c ? (!!c.customer.invoiceMobile && c.customer.invoiceMobile != null ? c.customer.invoiceMobile.replace(/\s/g, '') : '') : (!!n.invoice.mobile && n.invoice.mobile != null ? n.invoice.mobile.replace(/\s/g, '') : ''),
            "cvr": null,
            "ean": null,
            "customerRemarks": null,
            "customerAttention": null
          },
          "delivery": {
            "skip": deliverySkip,
            "name": !!c ? c.delivery.customerName : n.delivery.name,
            "address": !!c ? c.delivery.customerAddress : n.delivery.address,
            "zipCode": !!c ? c.delivery.customerZipCode : n.delivery.zipCode,
            "city": !!c ? c.delivery.customerCity : n.delivery.city,
            "telephone": !!c ? (!!c.delivery.customerPhone && c.delivery.customerPhone != null ? c.delivery.customerPhone.replace(/\s/g, '') : '') : (!!n.delivery.phone && n.delivery.phone != null ? n.delivery.phone.replace(/\s/g, '') : ''),
            "mobile": !!c ? (!!c.delivery.customerMobile && c.delivery.customerMobile != null ? c.delivery.customerMobile.replace(/\s/g, '') : '') : (!!n.delivery.mobile && n.delivery.mobile != null ? n.delivery.mobile.replace(/\s/g, '') : ''),
            "email": !!c ? c.delivery.customerMail : n.delivery.email,
            "att": null,
            "ean": null
          },
          "contact": {
            "skip": contactSkip,
            "name": !!c ? c.contact.name : n.contact.name,
            "address": !!c ? c.contact.address : n.contact.address,
            "zipCode": !!c ? c.contact.zipCode : n.contact.zipCode,
            "city": !!c ? c.contact.city : n.contact.city,
            "telephone": !!c ? (!!c.contact.phone && c.contact.phone != null ? c.contact.phone.replace(/\s/g, '') : '') : (!!n.contact.phone && n.contact.phone != null ? n.contact.phone.replace(/\s/g, '') : ''),
            "mobile": !!c ? (!!c.contact.mobile && c.contact.mobile != null ? c.contact.mobile.replace(/\s/g, '') : '') : (!!n.contact.mobile && n.contact.mobile != null ? n.contact.mobile.replace(/\s/g, '') : ''),
            "email": !!c ? c.contact.email : n.contact.email,
            "att": null,
            "ean": null
          },
          "responsibleId": n.responsibleId,
          "requisitionNumber": n.requisitionNumber,
          "disableNotifications": true,
          "caseNumber": null,
          "reference": n.reference,
          "caseTypeId": null,
          "caseChannel": null
        }
        this.acceptCase(d, sendToERP);
      }
    }
  }

  reloadDetails(caseId) {
    this.reload.emit(true);
    this.router.navigateByUrl("/Details/" + caseId + '?mode=partner');
  }

  acceptCase(bodyData, sendToERP) {
    let caseId = '';
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.put(api.jubloApi + 'api/Website/CaseTransfer/CaseTransferStatus/' + this.newCaseCustomer.transferId + '/36249264-3ac4-446b-a85e-81220ebfd518',
      bodyData, { headers }).subscribe(
        (val: string) => {
          //console.log('Case transfer status set', val);
          caseId = val;
          if (!!caseId && !this.data.lightCustomer && sendToERP) {
            //console.log('Case id gotten')
            //console.log(this.data.activeIntegration)
            const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
            if (this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e') {
              this.httpClient.post(api.jubloApi + 'api/Minuba/CreateCase/' + caseId + '/' + this.data.activeIntegration,
                {}, { headers }).subscribe(
                  val => { },
                  response => { console.log('response', response); },
                  () => {
                    this.update.emit('caseSent');
                  }
                );
            }
            else {
              //console.log(this.osStatus)
              let d = {
                caseId: caseId,
                integrationId: this.data.activeIntegration,
                caseTypeId: this.data.activeIntegration == '58ecfda6-79a6-4507-80ac-29b6d025360b' ? this.input.caseTypeId : null,
                osDepartmentId: this.data.activeIntegration == '58ecfda6-79a6-4507-80ac-29b6d025360b' ? this.case.departmentId: null,
                osStatus: this.data.activeIntegration == '58ecfda6-79a6-4507-80ac-29b6d025360b' ? this.osStatus : null,
                customerGroupId: this.input.customerTypeId,
                economySystemGroupId: this.input.debitorTypeId,
                parentCaseId: this.input.parentCaseId,
                minubaCaseType: this.data.activeIntegration == '2fdf7795-d8dc-4dcc-863b-9654ef98b1a0' ? this.input.caseTypeId : null,
                foremanId: this.foreman.key,
                EOrderGroupId: this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEOrderGroup : null,
                EDimensionCarrierId: this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEDimensionCarrier : null,
                EDimensionDepartmentId: this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEDepartment : null,
                EPriceGroupId: this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEPriceGroup : null,
                EProfitGroupId: this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEProfitGroup : null,
                EDimensionPurposeId: this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEDimensionPurpose : null,
                ResponsibleId: this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.case.responsible.responsibleId : null,
                EProjectType: this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentCaseType : null,
              };
              //console.log("send data", d);
              this.httpClient.post(api.jubloApi + 'api/Minuba/CreateCase',
                d, { headers }).subscribe(
                  (val) => { },
                  (response) => { console.log('response', response); },
                  () => {
                    this.update.emit('caseSent');
                  }
                );
            }
            this.createdCaseId = caseId;
          } else if (!!caseId && (this.data.lightCustomer || !sendToERP)) {
            this.createdCaseId = caseId;
            this.update.emit('caseSent');

          }
          else { console.log('Case id not gotten'); }
        }, response => {
          console.log('Create case failed', response);
          this.dblClick = null;
          this.createdCaseId = null;
        }, () => {
          this.dblClick = null;
        }
      );
    this.update.emit('caseAccepted');
    this.newCaseCustomer = null;
    this.newCaseCustomerChanged = null;
  }

  rejectCase() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.put(api.jubloApi + 'api/Website/CaseTransfer/CaseTransferStatus/' + this.newCaseCustomer.transferId + '/789e1326-6655-4e98-bcd1-41c527e32d93',
      {}, { headers }).subscribe(
        val => { console.log(val); /*console.log('val', newCustomerId);*/ },
        response => { console.log(response) },
        () => {
          console.log('case rejected');
          this.update.emit('caseRejected');
        }
      );
  }

  testLog() {
    console.log("case data", this.case)
  }

  sendCase() {
    if (this.case.customer.customerId == null) {
      console.log('no customer id found on case')
      let newCustomerId;
      let newDeliveryId;
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      //Creating Customer
      this.httpClient.post(api.jubloApi + 'api/Website/Customer/AddCustomer', {
        "companyId": this.data.companyInfo.id,
        "customerName": this.case.customer.name,
        "customerAddress": this.case.customer.address,
        "customerZipCode": this.case.customer.zipCode,
        "customerCity": this.case.customer.city,
        "customerTelephone": (!!this.case.customer.phone && this.case.customer.phone != null ? this.case.customer.phone.replace(/\s/g, '') : ''),
        "customerEmail": this.case.customer.email,
        "customerMobile": (!!this.case.customer.mobile && this.case.customer.mobile != null ? this.case.customer.mobile.replace(/\s/g, '') : ''),
        "invoiceName": this.case.customer.name,
        "invoiceAddress": this.case.customer.address,
        "invoiceZipCode": this.case.customer.zipCode,
        "invoiceCity": this.case.customer.city,
        "invoiceTelephone": (!!this.case.customer.phone && this.case.customer.phone != null ? this.case.customer.phone.replace(/\s/g, '') : ''),
        "invoiceEmail": this.case.customer.email,
        "invoiceMobile": (!!this.case.customer.mobile && this.case.customer.mobile != null ? this.case.customer.mobile.replace(/\s/g, '') : '')
      }, { headers }).subscribe(
        val => { newCustomerId = val; /*console.log('val', newCustomerId);*/ },
        response => { /*console.log('response', response);*/ },
        () => {
          //Setting new Customer on Case
          this.httpClient.patch(api.jubloApi + 'api/Website/Case/ChangeCustomer/' + newCustomerId + '/' + this.case.caseId, {}, { headers }).subscribe(
            val => { /*console.log('val', val);*/ },
            response => { /*console.log('response', response);*/ },
            () => {
              //Creating DeliveryAddress
              this.httpClient.post(api.jubloApi + 'api/Website/Customer/AddDeliveryAddress', {
                "customerId": newCustomerId,
                "name": this.case.deliveryAddress.name,
                "address": this.case.deliveryAddress.address,
                "city": this.case.deliveryAddress.city,
                "zipCode": this.case.deliveryAddress.zipCode,
                "telephone": (!!this.case.customer.phone && this.case.customer.phone != null ? this.case.deliveryAddress.phone.replace(/\s/g, '') : ''),
                "mobile": (!!this.case.customer.mobile && this.case.customer.mobile != null ? this.case.deliveryAddress.mobile.replace(/\s/g, '') : ''),
                "email": this.case.deliveryAddress.email
              }, { headers }).subscribe(
                val => { newDeliveryId = val; /*console.log('val', newDeliveryId);*/ },
                response => { /*console.log('response', response);*/ },
                () => {
                  //Setting DeliveryAddress on Case
                  this.httpClient.patch(api.jubloApi + 'api/Website/Case/ChangeDelivery/' + newDeliveryId + '/' + this.case.caseId, {}, { headers }).subscribe(
                    val => { console.log('val', val); },
                    response => { console.log('response', response); },
                    () => {
                      //Sending case to integrationsystem
                      let d = {
                        "caseId": this.case.caseId,
                        "integrationId": this.data.activeIntegration,
                        "caseTypeId": this.data.activeIntegration == '58ecfda6-79a6-4507-80ac-29b6d025360b' ? this.input.caseTypeId : null,
                        "parentCaseId": this.input.parentCaseId,
                        "osDepartmentId": this.case.departmentId,
                        "customerGroupId": this.input.customerTypeId,
                        "economySystemGroupId": this.input.debitorTypeId,
                        "minubaCaseType": this.data.activeIntegration == '2fdf7795-d8dc-4dcc-863b-9654ef98b1a0' ? this.input.caseTypeId : null,
                        "foremanId": this.foreman.key,
                        "EOrderGroupId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEOrderGroup : null,
                        "EDimensionCarrierId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEDimensionCarrier : null,
                        "EDimensionDepartmentId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEDepartment : null,
                        "EPriceGroupId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEPriceGroup : null,
                        "EProfitGroupId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEProfitGroup : null,
                        "EDimensionPurposeId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEDimensionPurpose : null,
                        "ResponsibleId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.case.responsible.responsibleId : null,
                        "EProjectType": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentCaseType : null,
                        "osStatus": this.data.activeIntegration == '58ecfda6-79a6-4507-80ac-29b6d025360b' ? this.osStatus : null
                      };
                      //console.log(d)
                      this.httpClient.post(api.jubloApi + 'api/Minuba/CreateCase',
                        d, { headers }).subscribe(
                          val => { /*console.log('val', val);*/ },
                          response => { console.log('response', response); },
                          () => {
                            document.getElementById("transferCaseCloseModalBtn").click();
                            this.update.emit('caseSent');
                          }
                        );
                    }
                  );
                }
              );
            }
          );
        }
      );
    }
    else {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      let d = {
        "caseId": this.case.caseId,
        "integrationId": this.data.activeIntegration,
        "caseTypeId": this.data.activeIntegration == '58ecfda6-79a6-4507-80ac-29b6d025360b' ? this.input.caseTypeId : null,
        "parentCaseId": this.input.parentCaseId,
        "osDepartmentId": this.case.departmentId,
        "customerGroupId": this.input.customerTypeId,
        "economySystemGroupId": this.input.debitorTypeId,
        "minubaCaseType": this.data.activeIntegration == '2fdf7795-d8dc-4dcc-863b-9654ef98b1a0' ? this.input.caseTypeId : null,
        "foremanId": this.foreman.key,
        "EOrderGroupId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEOrderGroup : null,
        "EDimensionCarrierId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEDimensionCarrier : null,
        "EDimensionDepartmentId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEDepartment : null,
        "EPriceGroupId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEPriceGroup : null,
        "EProfitGroupId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEProfitGroup : null,
        "EDimensionPurposeId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentEDimensionPurpose : null,
        "ResponsibleId": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.case.responsible.responsibleId : null,
        "EProjectType": this.data.activeIntegration == '7e82cc3e-163e-4cb2-ba25-939fc339f021' || this.data.activeIntegration == 'b81c660a-bc82-4c6b-a820-4f8804bdf68e' ? this.currentCaseType : null,
        "osStatus": this.data.activeIntegration == '58ecfda6-79a6-4507-80ac-29b6d025360b' ? this.osStatus : null,
      };
      //console.log(d);
      this.httpClient.post(api.jubloApi + 'api/Minuba/CreateCase',
        d, { headers }).subscribe(
          (val) => { /*console.log('val', val);*/ },
          (response) => { console.log('response', response); },
          () => {
            this.update.emit('caseSent');
            document.getElementById("transferCaseCloseModalBtn").click();
          }
        );
    }
  }

  getPartners() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Partner/GetPartnersToCompany', { headers }).subscribe(
      (data: Array<PartnerCompany>) => {
        this.data.partners = data.sort((a,b)=> a.companyName.toLowerCase() < b.companyName.toLowerCase() ? -1 : 1);
        if (!!this.data.partners && this.data.partners.length > 0) {
          this.filterPartner();
        }
      },
      (response) => { console.log('Error!', response); },
      () => { }
    )
  }

  filterPartner() {
    let s = this.input.partnerFilter.toLowerCase();
    if (s != '') {
      this.data.showPartners = this.data.partners.filter(x => x.companyName.toLowerCase().match(s) ||
        x.vat != null && x.vat.toString().match(s) ||
        x.companyNumber != null && x.companyNumber.toString().match(s) ||
        x.companyName != null && x.companyName.toLowerCase().match(s) ||
        x.zipCode != null && x.zipCode.toString().match(s) ||
        x.address != null && x.address.toLowerCase().match(s) ||
        x.city != null && x.city.toLowerCase().match(s)
      )
    }
    else { this.data.showPartners = this.data.partners }
    //console.log(this.showPartners);
  }

  updatePartnerCase(caseId) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.put(api.jubloApi + 'api/Website/Case/EditCase/' + caseId, {
      "description": this.case.description,
      "requisitionNumber": this.case.requisitionNumber,
      "vorRef": this.case.vorRef
    }, { headers }).subscribe(
      (data) => {
        //console.log(data); 
      },
      (response) => { console.log('Error!', response) },
      () => { console.log('case is sent'); }
    )
  }

  cancelCase(caseId) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.patch(api.jubloApi + 'api/Website/Case/' + caseId + '/Set/Status/99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0', {}, { headers }).subscribe(
      val => { },
      response => { },
      () => { this.update.emit(true); }
    );
  }

  documentAddressChange(event) {
    this.customerList = event;
    //console.log(this.customerList);
    if (!!event.currentStep) { this.data.step = event.currentStep }
    if (!!event.customer) {
      if (this.case.caseId != null) {
        this.customerUpdate(event);
      }
      else {
        this.newCaseCustomerChanged = event;
      }
    }
  }

  customerUpdate(event) {
    this.customerData = event;
    if (this.customerChange && event.customer != null && event.customer.customerId != null && event.customer.customerId != this.case.customer.customerId) {
      this.switchCustomerOnCase(event.customer.customerId);
      this.customerChange = false;
    }
    if (event.delivery != null && event.delivery.deliveryId != null && event.delivery.deliveryId != this.case.deliveryAddress.id) {
      this.switchDeliveryOnCase(event.delivery.deliveryId)
    }
    if (event.contact != null && event.contact.id != null && event.contact.id != this.case.contactAddress.id) {
      this.switchContactOnCase(event.contact.id)
    }
  }

  switchCustomerOnCase(id) {
    if (this.case.caseId != null) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.patch(api.jubloApi + 'api/Website/Case/ChangeCustomer/' + id + '/' + this.case.caseId, {}, { headers }).subscribe(
        (data) => { this.case.customer = this.customerData.customer },
        (response) => { },
        () => { }
      )
    }
  }

  switchDeliveryOnCase(id) {
    if (this.case.caseId != null) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.patch(api.jubloApi + 'api/Website/Case/ChangeDelivery/' + id + '/' + this.case.caseId, {}, { headers }).subscribe(
        (data) => { this.case.deliveryAddress = this.customerData.delivery },
        (response) => { },
        () => { }
      )
    }
  }

  switchContactOnCase(id) {
    if (this.case.caseId != null) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.patch(api.jubloApi + 'api/Website/Case/ChangeContact/' + id + '/' + this.case.caseId, {}, { headers }).subscribe(
        (data) => { this.case.contactAddress = this.customerData.contact },
        (response) => { },
        () => { }
      )
    }
  }

  getEOrderGroups() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Outbox/Ekomplet/OrderGroup', { headers }).subscribe(
      (data) => {
        //console.log(data)
        this.eorderGroupList = data;
      },
      (response) => { console.log('Error!', response) }
    )
  }

  getEDepartments() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Outbox/Ekomplet/Department', { headers }).subscribe(
      (data) => {
        //console.log(data)
        this.edepartmentList = data;
      },
      (response) => { console.log('Error!', response) }
    )
  }

  getEDimensionCarriers() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Outbox/Ekomplet/DimensionCarrier', { headers }).subscribe(
      (data) => {
        //console.log(data)
        this.edimensionCarrierList = data;
      },
      (response) => { console.log('Error!', response) }
    )
  }

  popper() {
    let f = document.getElementById('btnAccept');
    let v = document.getElementById('tooltip');
    if (v.hidden == true) { v.hidden = false }
    else { return v.hidden = true }
    createPopper(f, v, {
      placement: 'left',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],

          },
        }]
    })

  }

  popperCheck() {
    let v = document.getElementById('tooltip');
    if (v.hidden == true) { return }
    else { return v.hidden = true }
  }

  checkPhoneOnIntegration(sendToERP) {
    //return console.log(this.data.integrationId, this.data.lightCustomer, typeof this.data.integrationId);
    if ((!!this.data.integrationId && this.data.integrationId != 'null' && this.data.integrationId != '2fdf7795-d8dc-4dcc-863b-9654ef98b1a0') || !this.data.lightCustomer) {
      if (!this.customerList.customer.customerMobile && !this.customerList.customer.customerPhone && !this.customerList.customer.customerNumber) {
        this.popper();
        return
      } else {
        this.popperCheck();
        return this.updateAndSend(sendToERP);
      }
    } else {
      this.popperCheck();
      return this.updateAndSend(sendToERP);
    }
  }

  parentCase(e) {
    this.input.parentCaseId = e.caseId;
  }
}

export class CaseTransferDataHolder {
  integrationId: string;
  activeIntegration: string;
  responsibles: Array<Responsible>;
  companyInfo: CompanyInformation;
  fitters: Array<Fitter>;
  departments: Department[];
  osStatuses: Array<any>;
  companyUsers: Array<CompanyUsers>;
  partners: Array<PartnerCompany>;
  showPartners: Array<PartnerCompany>;
  caseTypes: Array<any>;
  customerTypes: Array<any>;
  debitorTypes: Array<any>;
  step: string = 'final';
  documentAddressMessage: string;
  lightCustomer: boolean;
}

export class CaseTransferChanges {
  caseTypeId: string;
  customerTypeId: string;
  parentCaseId: string;
  debitorTypeId: string;
  caseTask: CaseTask;
  planDate;
  planTime = '08:00';
  planHours = '1';
  planMinutes = '00';
  planFitter = null;
  cancelOrder = false;
  rejectOrder = false;
  selectPartner = false;
  partnerFilter = '';
  chosenPartner;
}

export class TimePickerRanges {
  dueTimes = [
    '00:00', '00:15', '00:30', '00:45', '01:00', '01:15', '01:30', '01:45', '02:00', '02:15', '02:30', '02:45', '03:00', '03:15', '03:30', '03:45',
    '04:00', '04:15', '04:30', '04:45', '05:00', '05:15', '05:30', '05:45', '06:00', '06:15', '06:30', '06:45', '07:00', '07:15', '07:30', '07:45',
    '08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45',
    '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45',
    '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00', '19:15', '19:30', '19:45',
    '20:00', '20:15', '20:30', '20:45', '21:00', '21:15', '21:30', '21:45', '22:00', '22:15', '22:30', '22:45', '23:00', '23:15', '23:30', '23:45'
  ];
  durationHours = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  durationMinutes = ['00', '15', '30', '45'];
}
